import { render, staticRenderFns } from "./HealthCheck60Register.vue?vue&type=template&id=dd466614&scoped=true&"
import script from "./HealthCheck60Register.vue?vue&type=script&lang=js&"
export * from "./HealthCheck60Register.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck60Register.vue?vue&type=style&index=0&id=dd466614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd466614",
  null
  
)

export default component.exports